export type NavLink = {
  label: string
  to: string
}

export const pillarNav: NavLink[] = [
  { label: 'Cuerpo', to: '/' },
  { label: 'Mente', to: '/mente' },
  { label: 'Espíritu', to: '/espiritu' },
  { label: 'Relaciones', to: '/relaciones' },
  { label: 'Finanzas', to: '/finanzas' },
]

export const socialLinks = ['Instagram', 'TikTok', 'YouTube']
